<template>
    <Listbox :modelValue="currentItem" @update:modelValue="e => updateModel(e)" as="div" :disabled="disabled">
        <label v-if="!noLabel" :class="{'dark:text-gray-100': darkEnabled}" class="block text-sm font-medium text-gray-700">{{ label }}</label>
        <div class="relative mt-1">
            <ListboxButton :class="[flat ? 'py-1 pr-8' : 'py-2 pl-3 pr-10 shadow-md']" class="relative w-full cursor-pointer rounded-lg bg-white text-left focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-orange-300 sm:text-sm">
                <span class="block truncate text-gray-800">{{ currentItem.name }}</span>
                <span class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                    <SelectorIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
                  </span>
            </ListboxButton>

            <transition
                leave-active-class="transition duration-100 ease-in"
                leave-from-class="opacity-100"
                leave-to-class="opacity-0">
                <ListboxOptions class="absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm z-10">
                    <ListboxOption
                        v-slot="{ active, selected }"
                        v-for="option in options"
                        :key="option.name"
                        :value="option"
                        :disabled="option.disabled"
                        as="template">
                        <li :class="[
                            option.disabled ? 'bg-gray-100 text-gray-300' : 'text-gray-900',
                            flat ? 'p-2' : 'py-2 pl-10 pr-4',
                            'relative cursor-default hover:bg-gray-50 cursor-pointer select-none'
                        ]">
                            <span :class="[
                                selected ? 'font-medium' : 'font-normal',
                                'block truncate',
                            ]">{{ option.name }}</span>
                            <span
                                v-if="!flat && selected"
                                class="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-900"
                            >
                              <CheckIcon class="h-5 w-5" aria-hidden="true" />
                            </span>
                        </li>
                    </ListboxOption>
                </ListboxOptions>
            </transition>
        </div>
    </Listbox>
</template>
<script>
import { ref } from 'vue'
import {
    Listbox,
    ListboxButton,
    ListboxOptions,
    ListboxOption,
} from '@headlessui/vue'
import { CheckIcon, SelectorIcon } from '@heroicons/vue/solid'

export default {
    props: {
        noLabel: {
            type: Boolean,
            default: false,
        },
        flat: {
            type: Boolean,
            default: false,
        },
        valueField: {
            type: String,
            default: 'value',
        },
        label: {
            type: String,
            default: "Input"
        },
        darkEnabled: {
            type: Boolean,
            default: false
        },
        selectedItem: {
            type: Object,
            default: { name: 'Option #2', value: '2', disabled: false }
        },
        options: {
            type: Array,
            default: [
                { name: 'Option #1', value: '1', disabled: false },
                { name: 'Option #2', value: '2', disabled: true },
            ]
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    emits: ['change'],
    components: {
        Listbox,
        ListboxButton,
        ListboxOptions,
        ListboxOption,

        CheckIcon,
        SelectorIcon
    },
    data() { return {}},
    setup(props) {
        let selItem = props.selectedItem ? props.options.filter(o => o[props.valueField] === props.selectedItem[props.valueField]) : [];
        const currentItem = ref(selItem.length ? selItem[0] : props.options[0])

        return {
            currentItem,
        }
    },
    methods: {
        updateModel($event) {
            if (this.currentItem[this.valueField] !== $event[this.valueField]) {
                this.currentItem = $event;
                this.$emit('change', $event);
            }
        }
    }
}
</script>
